import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import qs from 'qs';
import helpers from '../util/helpers';
import * as constants from '../util/constants';

const GiftsSkeleton = () => {
  return (
    <Fragment>
      {
        Array.from(Array(4).keys()).map((i) => {
          return (
            <div key={i} className="gift-item skeleton">
              <div className="gift-item-image-container">
                <div className="gift-item-image-wrapper skeleton-shine" />
              </div>
              <div className="gift-item-details-wrapper">
                <div className="gift-item-title skeleton-shine" />
                <div className="gift-item-tags">
                  <div className="gift-item-tag skeleton-shine" />
                </div>
                <div className="gift-item-description skeleton-shine" />
                <div className="gift-item-extra-details-wrapper">
                  <div>
                    <div className="gift-item-price-prepend skeleton-shine" />
                    <div className="gift-item-price skeleton-shine" />
                  </div>
                  <div className="gift-item-link-wrapper">
                    <div className="gift-item-link skeleton-shine" />
                  </div>
                </div>
              </div>
            </div>
          );
        })
      }
    </Fragment>
  );
};

class AppGifts extends Component {
  constructor(props) {
    super(props);

    // Initial state
    this.initialState = {
      loading: true,
      giftsCount: 0,
      allGifts: [],
      loadMoreLoading: false,
      loadedAll: false,
    };

    // Assign first state
    this.state = Object.assign({}, this.initialState);

    this.occasion = '';
    this.recipient = '';
    this.voucherType = '';

    const occasion = helpers.getParameterByName('occasion');
    if (occasion != null && occasion.length) {
      this.occasion = occasion;
    }

    const recipient = helpers.getParameterByName('recipient');
    if (recipient != null && recipient.length) {
      this.recipient = recipient;
    }

    const voucherType = helpers.getParameterByName('voucher-type');
    if (voucherType != null && voucherType.length) {
      this.voucherType = voucherType;
    }

    // Bind "this"
    this.loadGifts = this.loadGifts.bind(this);
    this.loadMoreGifts = this.loadMoreGifts.bind(this);

    // Cancel token source
    this.source = axios.CancelToken.source();
  }

  componentDidMount() {
    this.loadGifts();

    $(document).on(constants.EVENT_GIFTS_OCCASION_FILTER_CHANGED, (e, occasion) => {
      if (this.occasion !== occasion) {
        this.occasion = occasion;
        this.loadGifts();
      }
    });

    $(document).on(constants.EVENT_GIFTS_RECIPIENT_FILTER_CHANGED, (e, recipient) => {
      if (this.recipient !== recipient) {
        this.recipient = recipient;
        this.loadGifts();
      }
    });

    $(document).on(constants.EVENT_GIFTS_VOUCHER_TYPE_FILTER_CHANGED, (e, voucherType) => {
      if (this.voucherType !== voucherType) {
        this.voucherType = voucherType;
        this.loadGifts();
      }
    });

    $(document).on(constants.EVENT_GIFTS_DELIVERY_METHOD_FILTER_CHANGED, (e, deliveryMethod) => {
      if (this.deliveryMethod !== deliveryMethod) {
        this.deliveryMethod = deliveryMethod;
        this.loadGifts();
      }
    });

    $(document).on(constants.EVENT_GIFTS_SORT_CHANGED, (e, sort) => {
      if (this.sort !== sort) {
        this.sort = sort;
        this.loadGifts();
      }
    });

    $(document).on(constants.EVENT_GIFTS_SEARCH_FILTER_CHANGED, (e, search) => {
      if (this.search !== search) {
        this.search = search;
        this.loadGifts();
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.loading ||
      (prevState.loading && !this.state.loading)
    ) {
      const giftsCount = $('.section-hotel-gift-cards-results .gifts-count');
      if (giftsCount.length) {
        if (this.state.loading) {
          giftsCount.text('');
        } else {
          giftsCount.text(`Showing ${this.state.giftsCount} results`);
        }
      }
    }
  }

  loadGifts() {
    // Reset state
    this.setState(this.initialState);

    // Params
    const data = {
      'action': constants.ACTION_GET_HOTEL_GIFTS,
      'occasion': this.occasion,
      'recipient': this.recipient,
      'voucherType': this.voucherType,
      'deliveryMethod': this.deliveryMethod,
      'sort': this.sort,
      'search': this.search,
      'offset': 0,
    };

    // Send request
    axios.post(window.Rydges['ajaxUrl'], qs.stringify(data), {
      cancelToken: this.source.token,
    }).then((axiosResponse) => {
      if (200 === axiosResponse.status) {
        const response = axiosResponse.data;

        if (response.success) {
          const giftsCount = response.data['gifts_count'];
          const gifts = response.data['gifts'];

          if (giftsCount > 0) {
            this.setState({
              loading: false,
              giftsCount,
              allGifts: [...gifts],
              loadMoreLoading: false,
              loadedAll: parseInt(giftsCount) === gifts.length,
            });
          } else {
            this.setState({
              loading: false,
              giftsCount: 0,
              allGifts: [],
              loadMoreLoading: false,
              loadedAll: true,
            });
          }
        } else {
          this.setState({
            loading: false,
            giftsCount: 0,
            allGifts: [],
            loadMoreLoading: false,
            loadedAll: true,
          });
        }
      }
    }).catch((error) => {
      console.log(error);
    });
  }

  loadMoreGifts() {
    const {
      allGifts,
      loadedAll,
    } = this.state;

    if (!loadedAll) {
      this.setState({
        loading: false,
        loadMoreLoading: true,
      });

      // Params
      const data = {
        'action': constants.ACTION_GET_HOTEL_GIFTS,
        'occasion': this.occasion,
        'recipient': this.recipient,
        'voucherType': this.voucherType,
        'deliveryMethod': this.deliveryMethod,
        'sort': this.sort,
        'search': this.search,
        'offset': allGifts.length,
      };

      // Send request
      axios.post(window.Rydges['ajaxUrl'], qs.stringify(data), {
        cancelToken: this.source.token,
      }).then((axiosResponse) => {
        if (200 === axiosResponse.status) {
          const response = axiosResponse.data;

          if (response.success) {
            const giftsCount = response.data['gifts_count'];
            const gifts = [
              ...allGifts,
              ...response.data['gifts'],
            ];

            if (giftsCount > 0) {
              this.setState({
                loading: false,
                allGifts: [...gifts],
                loadMoreLoading: false,
                loadedAll: parseInt(giftsCount) === gifts.length,
              });
            } else {
              this.setState({
                loading: false,
                loadMoreLoading: false,
                loadedAll: true,
              });
            }
          } else {
            this.setState({
              loading: false,
              loadMoreLoading: false,
              loadedAll: true,
            });
          }
        }
      }).catch((error) => {
        console.log(error);
      });
    }
  }

  render() {
    const {
      loading,
      allGifts,
      loadMoreLoading,
      loadedAll,
    } = this.state;

    return (
      <Fragment>
        {
          !loading && allGifts.length > 0 && (
            <Fragment>
              {
                allGifts.map((gift, i) => {
                  return (
                    <div key={i} className="gift-item">
                      <div className="gift-item-image-container">
                        <a href={gift['buy_now_link']}
                           className="gift-item-image-wrapper"
                           target="_blank"
                           rel="noopener noreferrer"
                        >
                          {
                            gift['image'].length > 0 && (
                              <img src={gift['image']}
                                   className="gift-item-image"
                                   loading="lazy"
                                   decoding="async"
                                   alt=""
                              />
                            )
                          }
                          {
                            gift['cta_label'].length > 0 && (
                              <div className="gift-item-cta-label">
                                {gift['cta_label']}
                              </div>
                            )
                          }
                        </a>
                      </div>
                      <div className="gift-item-details-wrapper">
                        {
                          gift['title'].length > 0 && (
                            <a href={gift['buy_now_link']}
                               target="_blank"
                               rel="noopener noreferrer"
                            >
                              <h4 className="gift-item-title">
                                {gift['title']}
                              </h4>
                            </a>
                          )
                        }
                        <div className="gift-item-tags">
                          {
                            gift['voucher_type'].length > 0 && (
                              <div className="gift-item-tag">
                                <span className="label">
                                  Voucher Type:
                                </span>
                                <span className="value">
                                  {gift['voucher_type']}
                                </span>
                              </div>
                            )
                          }
                        </div>
                        {
                          gift['description'].length > 0 && (
                            <div className="gift-item-description" dangerouslySetInnerHTML={{__html: gift['description']}} />
                          )
                        }
                        <div className="gift-item-extra-details-wrapper">
                          <div>
                            {
                              gift['price_prepend'].length > 0 && (
                                <div className="gift-item-price-prepend">
                                  {gift['price_prepend']}
                                </div>
                              )
                            }
                            {
                              gift['price'].length > 0 && (
                                <div className="gift-item-price">
                                  {gift['price']}
                                </div>
                              )
                            }
                          </div>
                          {
                            gift['buy_now_link'].length > 0 && (
                              <div className="gift-item-link-wrapper">
                                <a href={gift['buy_now_link']}
                                   className="btn btn-red gift-item-link"
                                   target="_blank"
                                   rel="noopener noreferrer"
                                >
                                  Buy now
                                </a>
                              </div>
                            )
                          }
                        </div>
                      </div>
                    </div>
                  );
                })
              }
            </Fragment>
          )
        }
        {
          !loading && allGifts.length === 0 && (
            <h3 className="text-center">No results found</h3>
          )
        }
        {
          (loading || loadMoreLoading) && (
            <GiftsSkeleton />
          )
        }
        {
          !loading && allGifts.length > 0 && (
            <div className="gifts-load-more-button-wrapper">
              <button className="gifts-load-more-button btn btn-red" disabled={loading || loadMoreLoading || loadedAll} onClick={this.loadMoreGifts}>
                {!loadedAll ? 'Load More' : 'That\'s All'}
              </button>
            </div>
          )
        }
      </Fragment>
    );
  }
}

export default {
  init() {},
  finalize() {
    // Render results
    const giftsWrapper = $('#gifts-wrapper');
    if (giftsWrapper.length) {
      ReactDOM.render(<AppGifts />, giftsWrapper[0]);
    }

    const giftOccasionsFilter = $('#gift-occasions-filter');
    if (giftOccasionsFilter.length) {
      giftOccasionsFilter.on('select2:select', function () {
        const _this = $(this);
        const selectedVal = _this.val();
        const params = helpers.getParameters();

        if (selectedVal !== '') {
          params['occasion'] = selectedVal;
        } else {
          delete params['occasion'];
        }

        // Push params to url
        helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

        $(document).trigger(constants.EVENT_GIFTS_OCCASION_FILTER_CHANGED, [selectedVal]);
      }).on('select2:unselect', function () {
        const params = helpers.getParameters();

        delete params['occasion'];

        // Push params to url
        helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

        $(document).trigger(constants.EVENT_GIFTS_OCCASION_FILTER_CHANGED, ['']);
      });
    }

    const giftRecipientsFilter = $('#gift-recipients-filter');
    if (giftRecipientsFilter.length) {
      giftRecipientsFilter.on('select2:select', function () {
        const _this = $(this);
        const selectedVal = _this.val();
        const params = helpers.getParameters();

        if (selectedVal !== '') {
          params['recipient'] = selectedVal;
        } else {
          delete params['recipient'];
        }

        // Push params to url
        helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

        $(document).trigger(constants.EVENT_GIFTS_RECIPIENT_FILTER_CHANGED, [selectedVal]);
      }).on('select2:unselect', function () {
        const params = helpers.getParameters();

        delete params['recipient'];

        // Push params to url
        helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

        $(document).trigger(constants.EVENT_GIFTS_RECIPIENT_FILTER_CHANGED, ['']);
      });
    }

    const giftVoucherTypesFilter = $('#gift-voucher-types-filter');
    if (giftVoucherTypesFilter.length) {
      giftVoucherTypesFilter.on('select2:select', function () {
        const _this = $(this);
        const selectedVal = _this.val();
        const params = helpers.getParameters();

        if (selectedVal !== '') {
          params['voucher-type'] = selectedVal;
        } else {
          delete params['voucher-type'];
        }

        // Push params to url
        helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

        $(document).trigger(constants.EVENT_GIFTS_VOUCHER_TYPE_FILTER_CHANGED, [selectedVal]);
      }).on('select2:unselect', function () {
        const params = helpers.getParameters();

        delete params['voucher-type'];

        // Push params to url
        helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

        $(document).trigger(constants.EVENT_GIFTS_VOUCHER_TYPE_FILTER_CHANGED, ['']);
      });
    }

    const giftDeliveryMethodsFilter = $('.gift-delivery-methods-filter-item input[name="deliveryMethod[]"]');
    if (giftDeliveryMethodsFilter) {
      giftDeliveryMethodsFilter.on('change', function() {
        const checked = $('.gift-delivery-methods-filter-item input[name="deliveryMethod[]"]:checked');
        let selectedVal = [];

        if (checked.length) {
          checked.each(function() {
            const _this = $(this);
            const val = _this.val();

            selectedVal.push(val);
          });
        }

        $(document).trigger(constants.EVENT_GIFTS_DELIVERY_METHOD_FILTER_CHANGED, [selectedVal.join(',')]);
      });
    }

    const giftSortItems = $('#gift-sort-items');
    if (giftSortItems.length) {
      giftSortItems.on('select2:select', function () {
        const _this = $(this);
        const selectedVal = _this.val();

        $(document).trigger(constants.EVENT_GIFTS_SORT_CHANGED, [selectedVal]);
      });
    }

    const giftsSearchInput = $('.gifts-search-input');
    if (giftsSearchInput.length) {
      const searchIcon = giftsSearchInput.siblings('.search-icon');
      const clearButton = giftsSearchInput.siblings('.clear-button');
      let timeout = 0;

      giftsSearchInput.on('keyup', function () {
        const _this = $(this);
        const selectedVal = _this.val();

        if (selectedVal.length > 0) {
          searchIcon.hide();
          clearButton.show();
        } else {
          searchIcon.show();
          clearButton.hide();
        }

        clearTimeout(timeout);

        timeout = setTimeout(function () {
          $(document).trigger(constants.EVENT_GIFTS_SEARCH_FILTER_CHANGED, [selectedVal]);
        }, 500);
      });

      clearButton.on('click', function() {
        giftsSearchInput.val('');
        giftsSearchInput.trigger('keyup');
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateHotelGiftCards.js